/**
 *
 *  a dedicated class for doing positioning
 * @param {*} configurations
 * @param {*} context optional document object to cater parent and iframe based DOM manipulation alike
 * @returns
 */
import Positioner from './Positioner';

export default class TabPositioner extends Positioner {
    constructor(configurations, context) {
        super(configurations, context);
        const me = this;
        me.configuration = configurations;
        me.DOM = context || document;
    }

    position(options) {
        const me = this;
        const tempDOM = me.DOM;
        if (options.context) {
            me.DOM = options.context;
        }
        const { element, isIframeOuterObject } = options;
        let targetObj;
        if (typeof element === 'object') {
            targetObj = element;
        } else {
            const pureElement = this.getPureElement(element);
            targetObj = this.getElement(element, pureElement);
        }
        targetObj.style.paddingLeft = '10px';
        targetObj.style.paddingRight = '10px';
        targetObj.style.height = this.configuration.chatTab.height;
        if (targetObj) {
            const iframe = targetObj.querySelector('#apexchat_tab_invitation_frame');
            if (iframe) {
                iframe.style.width = 'auto';
            }
        }

        targetObj.style.display = 'block';
        let trans = 0;
        if (this.configuration.chatTab.chatTabLeftSide) {
            trans = -45 + this.configuration.chatTab.chatTabTrans;
            // targetObj.style.left = 0;
            // targetObj.style.marginLeft = this.configuration.chatTab.borderWidth;
            targetObj.style.borderBottomRightRadius = this.configuration.chatTab.borderRadius;
            targetObj.style.borderBottomLeftRadius = this.configuration.chatTab.borderRadius;
            targetObj.style.marginTop = '-10px';
        } else {
            trans = 45 + this.configuration.chatTab.chatTabTrans;
            targetObj.style.right = 0;
            targetObj.style.borderTopRightRadius = this.configuration.chatTab.borderRadius;
            targetObj.style.borderTopLeftRadius = this.configuration.chatTab.borderRadius;
        }
        if (isIframeOuterObject === true) {
            targetObj.style.transform = `translateX(${trans}%) translateY(-50%) rotate(-90deg)`;
            targetObj.style.paddingLeft = '0';
            targetObj.style.paddingRight = '0';
            const borderWidth = parseFloat(this.configuration.chatTab.borderWidth);
            if (this.configuration.chatTab.chatTabLeftSide) {
                if (borderWidth === 0) {
                    targetObj.style.marginLeft = '8px';
                }
            } else {
                // var marginValue = ;
                targetObj.style.marginRight = `${borderWidth + (borderWidth === 0 ? 10 : 20)}px`;
            }
        }
        if (this.configuration.chatTab.hover) {
            targetObj.className += 'cstDiv';
        }
        me.DOM = tempDOM;
    }
}
